import * as React from 'react';
import SuperCritical from 'lib/supercritical';

export const PilotSettingsView = SuperCritical(({ id } : { id : number }) =>
    <div className="pilotsettings pc-page-fixedwidth">
        <div className="pc-actions-links-header">
            <a className="pc-back-link" href="#!morepage">&lt;&lt; Back to More</a>
        </div>
        <h1 className="pc-page-title">
            <span className="pc-text-label-color">More</span><span className="pc-icon-bullet"></span>
            <span>Pilot Settings</span>
        </h1>
        <div className="page-body pc-card">
            <div className="managelookups-setting">
                <div className="setting-link">
                    {/* TH 01/17/2017 -- Original comment from Feb 2016:
                        TH: The multiple pilot agency question. For now, our solution is that each pilot agency gets its own Pilot Settings page. */}
                    <a href={'#!managepilotlookups?id=' + id}>Manage Lookups</a>
                </div>
                <div className="setting-description pc-text-smalllabel">
                    Manage lookup lists for pilots, agencies, tugs, and pier-side.
                    Set codes or nicknames for pilots and agencies.
                </div>
            </div>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./apps/pilots/pilotsettings/view.tsx